// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --label-color :rgba(0,0,0,.6);
}

.entry_form{
    margin-top: 6rem;
}

.form-control{
    border-radius: .15rem !important;
    -webkit-border-radius: .15rem !important;
    -moz-border-radius: .15rem !important;
    -ms-border-radius: .15rem !important;
}

.form-control-custom{
    height: 2.5rem;
}

.error{
    color: #FF4136;
    font-weight: 400;
    padding-top: 10px;
    display: block;
}

.form-control:focus {
    box-shadow: none !important;
}

.mx-datepicker {
    display: block !important;
    width: auto !important;
    font: inherit !important;
}

.mx-input-append{
    display: none !important;
}

.mx-calendar-content .cell.actived{
    background-color: var(--selected-color) !important;
}

.IZ-select__input{
    border-radius: .15rem !important
}

.IZ-select .IZ-select__input{
    height: 2.5rem !important; 
}

.po-product-search-btn{
    margin-top: 34px;
}

.file-input{
    padding: 3px;
}

.mx-datepicker-popup{
    z-index: 9999 !important;
}

label{
    color: var(--label-color);
    font-size: 13px;
    font-weight: 500;
}

.check-buttons{
    background: #f3f6f9;
    color: inherit;
    padding: 5px;
    padding-left: 15px;
    margin-bottom: 5px;
    border-radius: 2px;
    cursor: pointer;
    font-weight: 400;
}

.check-buttons:hover{
    color: #3699ff;
    background-color: #e1f0ff;
    border-color: transparent;
}

.check:checked ~ .check-buttons{
    color: #3699ff;
    background-color: #e1f0ff;
    border-color: transparent;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/GlobalModules/Utility/Public/css/custom-pos/form.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":[":root{\n    --label-color :rgba(0,0,0,.6);\n}\n\n.entry_form{\n    margin-top: 6rem;\n}\n\n.form-control{\n    border-radius: .15rem !important;\n    -webkit-border-radius: .15rem !important;\n    -moz-border-radius: .15rem !important;\n    -ms-border-radius: .15rem !important;\n}\n\n.form-control-custom{\n    height: 2.5rem;\n}\n\n.error{\n    color: #FF4136;\n    font-weight: 400;\n    padding-top: 10px;\n    display: block;\n}\n\n.form-control:focus {\n    box-shadow: none !important;\n}\n\n.mx-datepicker {\n    display: block !important;\n    width: auto !important;\n    font: inherit !important;\n}\n\n.mx-input-append{\n    display: none !important;\n}\n\n.mx-calendar-content .cell.actived{\n    background-color: var(--selected-color) !important;\n}\n\n.IZ-select__input{\n    border-radius: .15rem !important\n}\n\n.IZ-select .IZ-select__input{\n    height: 2.5rem !important; \n}\n\n.po-product-search-btn{\n    margin-top: 34px;\n}\n\n.file-input{\n    padding: 3px;\n}\n\n.mx-datepicker-popup{\n    z-index: 9999 !important;\n}\n\nlabel{\n    color: var(--label-color);\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.check-buttons{\n    background: #f3f6f9;\n    color: inherit;\n    padding: 5px;\n    padding-left: 15px;\n    margin-bottom: 5px;\n    border-radius: 2px;\n    cursor: pointer;\n    font-weight: 400;\n}\n\n.check-buttons:hover{\n    color: #3699ff;\n    background-color: #e1f0ff;\n    border-color: transparent;\n}\n\n.check:checked ~ .check-buttons{\n    color: #3699ff;\n    background-color: #e1f0ff;\n    border-color: transparent;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
